import { Instance } from 'mobx-state-tree'
import { UserResponseModelBase } from './UserResponseModel.base'
import { PermissionsResponseModelType } from '.'

/* The TypeScript type of an instance of UserResponseModel */
export interface UserResponseModelType
  extends Instance<typeof UserResponseModel.Type> {}

/* A graphql query fragment builders for UserResponseModel */
export {
  selectFromUserResponse,
  userResponseModelPrimitives,
  UserResponseModelSelector
} from './UserResponseModel.base'

type IfEquals<X, Y, A, B> = (<T>() => T extends X ? 1 : 2) extends <
  T
>() => T extends Y ? 1 : 2
  ? A
  : B

type WritableKeysOf<T> = {
  [P in keyof T]: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P,
    never
  >
}[keyof T]

export type Permission = WritableKeysOf<PermissionsResponseModelType>

/**
 * UserResponseModel
 */
export const UserResponseModel = UserResponseModelBase.views(self => ({
  get $permissions() {
    return self.permissions as PermissionsResponseModelType | undefined | null
  }
})).actions(self => ({
  // This is an auto-generated example action.
  setNickname(nickname: string) {
    self.nickName = nickname
  },
  setPermission(permission: Permission, value: boolean) {
    if (self.$permissions && permission) self.$permissions[permission] = value
  }
}))
